// removed by extract-text-webpack-plugin
module.exports = {"root":"_1u3u6RgGL7ervCht9rJgoQ","image":"_2OKRlNrpPG7ho8ilFw4l6x","circle":"_6yAabZkcbMn-lJNlXxTq9","cover":"_1gZG9-En801M7AukmTTts2","square":"Q_iIuy7ZubDM2dvnpSXfN","spinner-wrapper":"GAWZk6pnOLSE_KS2VbLvH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/image.scss
// module id = 1194
// module chunks = 0